<template>
  <modal-form v-model="show" size="lg" :show-submit="false" text-close="Fechar" body-class="pa-0">
    <template slot="title">
      Resumo da Proposta - {{ $api.UI.Format.LeftPadNumbers(model.CodigoProposta, 9) }}

      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn class="ml-8" color="primary" @click="baixarPDF" v-on="on" icon>
            <v-icon>ph-printer-bold</v-icon>
          </v-btn>
        </template>
        <span>Baixar PDF</span>
      </v-tooltip>

    </template>
    <template slot="body">
      <v-card flat>
        <v-card-text>
          <resumo-padrao ref="resumo" resumo-proposta modal></resumo-padrao>
        </v-card-text>
      </v-card>
    </template>
  </modal-form>
</template>

<script>
export default {
  data () {
    return {
      show: false,
      model: {},
    };
  },
  methods: {
    openModal (sender) {
      const th = this
      th.show = true
      th.loadParcelas(sender)
    },
    loadParcelas (sender) {
      const th = this

      if (sender.VencimentoPersonalizado) {
        const dto = {
          dto: {
            CodigoProposta: sender.Codigo
          }
        }
        th.$api.Multiplo.BuscarSimulacaoFluxoIrregular(dto).then(async function (response) {
          if (th.$api.UI.PostLoadData(response)) {
            sender = {
              ...sender,
              ...response.PMTIrregular.Resumo
            }

            th.carregaResumo(sender)
          }
        })
      } else {
        const dto = { parameters: [{ name: 'CodigoProposta', value: sender.Codigo }] }
        th.$api.Multiplo.ListPropostaParcela(dto).then(async function (response) {
          if (th.$api.UI.PostLoadData(response)) {
            if (response.Count === 0) {
              const dto = {
                codigoProposta: sender.Codigo,
                usarJurosProposta: true,
                calculoGradesParcelas: true,
                montaFluxoPagamentoEstatico: true,
              }
              th.$api.Multiplo.CalcularCamposProposta({ dto }).then(
                (result) => {
                  sender = {
                    ...sender,
                    ...result.Proposta
                  }
                  th.carregaResumo(sender)
                }
              );
            } else {
              sender.Parcelas = response.Data.map(p => {
                return {
                  NumeroParcela: p.NumeroParcela,
                  DtVencimento: p.DtVencimento,
                  VlrPrestacaoTotal: p.VlrParcela,
                  VlrAmortizacao: p.VlrAmortizacao,
                  VlrJurosAcumulado: p.VlrJurosAcumulado,
                  VlrSaldoDevedor: p.VlrSaldoDevedor,
                  Dias: th.$api.UI.Date.DaysBetween(response.Data[0].DtVencimento, p.DtVencimento) + th.$api.UI.Date.DaysBetween(th.$api.UI.Date.AddMonth(new Date(), 1), sender.DtPrimeiroVencto)
                }
              })
              th.carregaResumo(sender)
            }
          }
        })
      }
    },
    setModel (sender) {
      let valorTotalSolicitado = (sender.VlrSolicitado || 0)
      if (sender.TipoOperacaoCred === 3) { valorTotalSolicitado = (sender.VlrProdutoBem || 0) - (sender.VlrEntrada || 0) }
      valorTotalSolicitado += (sender.VlrTAC || 0) + (sender.VlrRegistro || 0)

      if (sender.OutrosServicos) { valorTotalSolicitado += (sender.VlrSeguro || 0) + (sender.VlrAvaliacao || 0) + (sender.VlrVistoria || 0) }
      const model = {
        Codigo: sender.Codigo,
        CodigoProposta: sender.CodigoProposta,
        Situacao: sender.Situacao,
        SituacaoDescricao: sender.SituacaoDescricao,
        CodigoCliente: sender.CodigoCliente,

        Cliente: {
          DocumentoFederal: sender.Cliente.DocumentoFederal,
          Nome: sender.Cliente.Nome,
        },

        TipoOperacaoCred: sender.TipoOperacaoCred,
        TipoOperacaoNome: sender.TipoOperacaoNome || sender.TipoOperacaoDescricao,
        TipoContratoDescricao: sender.TipoContratoDescricao,
        TipoCalculoFluxo: sender.VencimentoPersonalizado ? this.$aux.TipoFluxoEnum.Irregular : this.$aux.TipoFluxoEnum.Regular,
        PrimeiraParcela: sender.Parcelas[0],
        UltimaParcela: sender.Parcelas[sender.Parcelas.length - 1],
        Prazo: sender.QtdeParcelas || sender.QtdeParcelasSolicitado,

        VlrSolicitado: sender.TipoOperacaoCred === 3 ? (sender.VlrProdutoBem - sender.VlrEntrada) : sender.VlrSolicitado,
        VlrTAC: sender.VlrTAC,
        VlrTotalSolicitado: valorTotalSolicitado,
        VlrIOF: sender.VlrIOF,
        VlrTotalFinanciado: (sender.VlrIOF || 0) + valorTotalSolicitado,
        VlrTotalDivida: sender.VlrTotalDivida,

        OutrosServicos: sender.OutrosServicos,
        VlrSeguro: sender.VlrSeguro,
        VlrAvaliacao: sender.VlrAvaliacao,
        VlrVistoria: sender.VlrVistoria,
        VlrRegistro: sender.VlrRegistro,

        PercIndiceFinan: sender.PercIndiceFinan,
        PercJurosMensal: sender.PercJurosMensal,
        PercJurosAnual: sender.PercJurosAnual,
        PercCETMensal: sender.PercCETMensal,
        PercCETAnual: sender.PercCETAnual,
        ModeloCalculo: sender.ModeloCalculo,
        TipoIndexador: sender.TipoIndexador,
        TipoIndiceFinan: sender.TipoIndiceFinan,

        Parcelas: sender.Parcelas,
      }
      return model
    },
    async carregaResumo (sender) {
      const th = this

      const model = th.setModel(sender)
      const obj = await th.$api.Multiplo.CarregaDadosPessoa(model.Cliente.DocumentoFederal)

      if (obj.PessoaDadosContato) {
        th.$set(model.Cliente, 'PessoaDadosContato', obj.PessoaDadosContato)
        th.$set(model.Cliente.PessoaDadosContato, 'TelefoneCelular1', th.$api.UI.Format.Celular(obj.PessoaDadosContato.TelefoneCelular1))
      }
      if (obj.PessoaDadosEndereco) {
        th.$set(model.Cliente, 'PessoaEndereco', obj.PessoaDadosEndereco)
      }
      th.$api.UTIL.Functions.SetAllButNull(th, th, 'model', model)
      th.$nextTick(() => {
        th.$refs.resumo.load(model)
      })
    },
    baixarPDF (callback) {
      const th = this
      const nomeArquivo = `Proposta-${th.$api.UI.Format.LeftPadNumbers(th.model.CodigoProposta, 9)}-${th.model.Cliente.Nome}.pdf`
      const dto = th.getParams(nomeArquivo)

      th.$api.Multiplo.GetPDF(dto).then(function (response) {
        if (th.$api.UI.PostLoadData(response, true)) {
          const url = window.URL.createObjectURL(response.data);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', nomeArquivo);
          document.body.appendChild(link);
          link.click();
          th.step++
        }
      })
    },
    getParams (nomeArquivo) {
      const th = this
      const dto = {
        parameters: [
          { name: 'PATH', value: 'estruturadas/' },
          { name: 'FILE_TEMPLATE', value: 'pdf-simulacao.html' },
          { name: 'FILE_NAME', value: nomeArquivo },
          { name: 'FILE_FOOTER_TEXT', value: 'Este empréstimo será intermediado pelo BMP Money Plus como Correspondente Bancário do Banco Central' },
          { name: 'Codigo', value: th.model.Codigo },
          { name: 'NomeCliente', value: th.model.Cliente.Nome },

          { name: 'CELULAR', value: th.model.Cliente.PessoaDadosContato.TelefoneCelular1 },
          { name: 'EMAIL', value: th.model.Cliente.PessoaDadosContato.Email },
          { name: 'CEP', value: th.model.Cliente.PessoaEndereco.CEP },
          { name: 'BAIRRO', value: th.model.Cliente.PessoaEndereco.Bairro },
          { name: 'CIDADE', value: th.model.Cliente.PessoaEndereco.Cidade },
          { name: 'LOGRADOURO', value: th.model.Cliente.PessoaEndereco.Logradouro },
          { name: 'NUMERO', value: th.model.Cliente.PessoaEndereco.NroLogradouro },
          { name: 'UF', value: th.model.Cliente.PessoaEndereco.UF },
          { name: 'COMPLEMENTO', value: th.model.Cliente.PessoaEndereco.Complemento },

          { name: 'HEADER_LOGO', value: 'logo.png' },
          { name: 'CSS_FILE', value: 'email.css' },
          { name: 'VLRTOTALCREDITO', value: th.$api.UI.Format.Currency(th.model.VlrTotalCredito) },

          { name: 'DOCUMENTOFEDERAL', value: th.model.Cliente.DocumentoFederal },
          { name: 'NOME', value: th.model.Cliente.Nome },
          { name: 'TIPOOPERACAO', value: th.model.TipoOperacaoNome },
          { name: 'TIPOPRODUTO', value: th.model.TipoContratoDescricao },
          { name: 'VLRPRIMEIRAPARCELA', value: th.$api.UI.Format.Currency(th.model.PrimeiraParcela.VlrPrestacaoTotal) },
          { name: 'DTVENCTOPRIMEIRAPARCELA', value: th.$api.UI.Format.Date(th.model.PrimeiraParcela.DtVencimento) },
          { name: 'VLRULTIMAPARCELA', value: th.$api.UI.Format.Currency(th.model.UltimaParcela.VlrPrestacaoTotal) },
          { name: 'DTVENCTOULTIMAPARCELA', value: th.$api.UI.Format.Date(th.model.UltimaParcela.DtVencimento) },
          { name: 'PRAZO', value: th.model.Prazo },

          { name: 'VLRSOLICITADO', value: th.$api.UI.Format.Currency(th.model.VlrSolicitado) },
          { name: 'VLRTAC', value: th.$api.UI.Format.Currency(th.model.VlrTAC) },
          { name: 'VLRTOTALSOLICITADO', value: th.$api.UI.Format.Currency(th.model.VlrTotalSolicitado) },
          { name: 'VLRIOF', value: th.$api.UI.Format.Currency(th.model.VlrIOF) },
          { name: 'VLRTOTALFINANCIADO', value: th.$api.UI.Format.Currency(th.model.VlrTotalFinanciado) },
          { name: 'VLRTOTALDIVIDA', value: th.$api.UI.Format.Currency(th.model.VlrTotalDivida) },

          { name: 'STYLEVLRSEGURO', value: !th.model.OutrosServicos || th.model.VlrSeguro <= 0 ? 'display: none;' : '' },
          { name: 'VLRSEGURO', value: th.$api.UI.Format.Currency(th.model.VlrSeguro) },
          { name: 'STYLEVLRAVALIACAO', value: !th.model.OutrosServicos || th.model.VlrAvaliacao <= 0 ? 'display: none;' : '' },
          { name: 'VLRAVALIACAO', value: th.$api.UI.Format.Currency(th.model.VlrAvaliacao) },
          { name: 'STYLEVLRVISTORIA', value: !th.model.OutrosServicos || th.model.VlrVistoria <= 0 ? 'display: none;' : '' },
          { name: 'VLRVISTORIA', value: th.$api.UI.Format.Currency(th.model.VlrVistoria) },
          { name: 'STYLEVLRREGISTRO', value: th.model.VlrRegistro <= 0 ? 'display: none;' : '' },
          { name: 'VLRREGISTRO', value: th.$api.UI.Format.Currency(th.model.VlrRegistro) },

          { name: 'PERCJUROSMENSAL', value: th.$api.UI.Format.Decimal(th.model.PercJurosMensal) },
          { name: 'PERCJUROSANUAL', value: th.$api.UI.Format.Decimal(th.model.PercJurosAnual) },
          { name: 'PERCJUROSSUFIXO', value: th.model.ModeloCalculo !== th.$api.Estruturadas.ModeloCalculoEnum.Price ? 'a.a.' : 'a.m.' },
          { name: 'PERCCETMENSAL', value: th.$api.UI.Format.Decimal(th.model.PercCETMensal) },
          { name: 'PERCCETANUAL', value: th.$api.UI.Format.Decimal(th.model.PercCETAnual) },
          { name: 'MODELOCALCULO', value: th.model.ModeloCalculo === th.$api.Estruturadas.ModeloCalculoEnum.Price ? 'Price' : 'SAC' },
          { name: 'MODALIDADE', value: th.model.TipoIndexador === 1 ? 'Pré-Fixado' : 'Pós-Fixado' },

          { name: 'VENDEDORNOME', value: th.$user.identificador },
          { name: 'VENDEDOREMAIL', value: th.$user.email },
          { name: 'EMPRESANOME', value: th.$empresa.nome },
          { name: 'EMPRESADOCUMENTO', value: th.$empresa.documentoFederal },
          {
            name: 'TEMPLATE_FLUXO', value: `
              <tr>
                <td style="text-align:center">##FLUXO_PARCELAS##</td>
                <td style="text-align:center">##FLUXO_VENCIMENTO##</td>
                <td style="text-align:right">##FLUXO_PRESTACAO##</td>
                <!--<td style="text-align:right">##FLUXO_AMORTIZACAO##</td>
                <td style="text-align:right">##FLUXO_JUROS##</td>-->
                <td style="text-align:right">##FLUXO_SALDO##</td>
              </tr>`
          },
          { name: 'FLUXO_QTD', value: th.model.Parcelas.length }
        ]
      }
      for (var i = 0; i < th.model.Parcelas.length; i++) {
        dto.parameters.push({ name: 'FLUXO_PARCELAS_' + i, value: i + 1 })
        dto.parameters.push({ name: 'FLUXO_VENCIMENTO_' + i, value: th.$api.UI.Format.Date(th.model.Parcelas[i].DtVencimento) })
        dto.parameters.push({ name: 'FLUXO_PRESTACAO_' + i, value: th.$api.UI.Format.Currency(th.model.Parcelas[i].VlrPrestacaoTotal) })
        dto.parameters.push({ name: 'FLUXO_SALDO_' + i, value: th.$api.UI.Format.Currency(th.model.Parcelas[i].VlrSaldoDevedor) })
        // dto.parameters.push({ name: 'FLUXO_AMORTIZACAO_' + i, value: th.$api.UI.Format.Currency(th.model.Parcelas[i].VlrAmortizacao) })
        // dto.parameters.push({ name: 'FLUXO_JUROS_' + i, value: th.$api.UI.Format.Currency(th.model.Parcelas[i].VlrJurosAcumulado) })
      }
      if (th.model.TipoIndexador === 2) {
        dto.parameters.push({ name: 'STYLEPOSFIXADO', value: null })
        dto.parameters.push({ name: 'INDEXADORPOSFIXADO', value: th.$api.Estruturadas.Indexador.find(p => p.value === th.model.TipoIndiceFinan)?.text })
        dto.parameters.push({ name: 'PERCINDICEFINAN', value: th.model.PercIndiceFinan })
      } else {
        dto.parameters.push()
        dto.parameters.push({ name: 'STYLEPOSFIXADO', value: 'display: none;' })
      }

      return dto
    }
  }
};
</script>
